import { Builder } from "@builder.io/react";
import { Core } from "@faire/design-tokens";

import { TextComponent } from "../../BuilderComponents/CustomText/CustomText";

export const registerBuilderRichText = () => {
  Builder.registerComponent(TextComponent, {
    name: "RichText",
    static: true,
    hideFromInsertMenu: true,
    inputs: [
      {
        name: "text",
        type: "html",
        required: true,
        autoFocus: true,
        bubble: true,
        defaultValue: "Enter some text...",
      },
      {
        name: "variant",
        type: "string",
        required: true,
        enum: [
          "displayXLSerifRegular",
          "displayLSerifRegular",
          "displayMSerifRegular",
          "displaySSerifRegular",
          "displaySSansSemiBold",
          "displaySSansRegular",
          "pageHeaderSerifRegular",
          "sectionHeaderSansMedium",
          "subheadingSansMedium",
          "subheadingSansRegular",
          "paragraphSansMedium",
          "paragraphSansRegular",
          "labelSansRegular",
          "labelSansMedium",
        ],
        defaultValue: "paragraphSansRegular",
      },
      {
        name: "as",
        type: "string",
        enum: ["h1", "h2", "h3", "h4", "h5", "p", "span", "label"],
      },
      {
        name: "color",
        type: "color",
        defaultValue: Core.text.primary,
      },
      {
        name: "truncate",
        type: "boolean",
      },
      {
        name: "maxLines",
        type: "number",
      },
    ],
  });
};
